import { render, staticRenderFns } from "./projectInside.vue?vue&type=template&id=18297a08&scoped=true&"
import script from "./projectInside.vue?vue&type=script&lang=js&"
export * from "./projectInside.vue?vue&type=script&lang=js&"
import style0 from "./projectInside.vue?vue&type=style&index=0&id=18297a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18297a08",
  null
  
)

export default component.exports